export const TABS = ['account', 'security', 'preferences'];
